const variables = {
  fullStarColor: '#00949b',
  emptyStarColor: '#ffffff',
  strokeColor: '#00949b',
};

export default variables;



// WEBPACK FOOTER //
// ./src/angelsoft/variables.js